import { render, staticRenderFns } from "./AllGlLevel1Table.vue?vue&type=template&id=64483d15&scoped=true&"
import script from "./AllGlLevel1Table.vue?vue&type=script&lang=js&"
export * from "./AllGlLevel1Table.vue?vue&type=script&lang=js&"
import style0 from "./AllGlLevel1Table.vue?vue&type=style&index=0&id=64483d15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64483d15",
  null
  
)

export default component.exports